export default "__VITE_ASSET__DZJ49HEV__"